import dynamic from 'next/dynamic'

export const DynamicBannerSkeleton = dynamic(() =>
	import('./BannerSkeleton').then(({ BannerSkeleton }) => BannerSkeleton)
)
